<template>
    <div>
        <transition name="slide-right-panel">
            <div class="side-panel right-sidebar shw-rside" v-if="show">
                <div class="rpanel-title">
                    {{ title }}
                    <span>
                        <i class="icon mdi mdi-close right-side-toggle" @click="closeNotesPanel"></i>
                    </span>
                </div>
                <div class="slimscrollright">
                    <div class="notes-list">
                        <div class="r-panel-body mb-2 mt-2">
                            <div class="card">
                                 <textarea
                                     v-model="newNote.noteText"
                                     class="form-control"
                                     type="text"
                                     style="height:80px"
                                     placeholder="Type Note Here"
                                     :class="{'is-invalid': newNote.errors.has('noteText')}"
                                 ></textarea>
                                <span class="invalid-feedback" v-show="newNote.errors.has('noteText')">
                                    {{ newNote.errors.get('noteText') }}
                                </span>
                                <button class="btn btn-outline-primary mt-1" @click.prevent="createNewNote">
                                    Create Note
                                </button>
                            </div>

                            <div class="notes-wrapper">
                                <div
                                    :key="note.id" v-for="note in mutableNotes"
                                     class="text-left border-bottom pb-2 pt-3"
                                >
                                    <div>
                                        <div>
                                            <h6>{{note.created_at | datetime}}</h6>
                                        </div>
                                        <div v-if="!editing || note.id!==selectedNote.noteId">
                                            <div>
                                                <p style="white-space: pre-wrap">{{note.note}}</p>
                                            </div>
                                            <span
                                                class="invalid-feedback"
                                                v-show="newNote.errors.has('noteText')"
                                            >
                                                {{ newNote.errors.get('noteText') }}
                                            </span>
                                        </div>
                                        <div v-else>
                                             <textarea
                                                 v-model="selectedNote.noteText"
                                                 class="form-control"
                                                 type="text"
                                                 style="height:80px"
                                                 placeholder="Type Note Here"
                                                 :class="{'is-invalid': selectedNote.errors.has('noteText')}"
                                             ></textarea>
                                            <span class="invalid-feedback" v-show="selectedNote.errors.has('noteText')">
                                                {{ selectedNote.errors.get('noteText') }}
                                            </span>
                                        </div>
                                        <footer class="overflow-auto">
                                            <small class="" v-if="note.author">
                                                Author : <cite title="Source Title">{{ note.author.name }}</cite>
                                            </small>
                                            <span class="pull-right">
                                                <a href="#" @click.prevent="showDeleteConfirmation(note.id)">
                                                    <i class="mdi mdi-delete-outline "></i>
                                                </a>
                                            </span>
                                            <span v-if="!editing || note.id!==selectedNote.noteId" class="pull-right">
                                                <a href="#" @click.prevent="editNote(note)">
                                                    <i class="mdi mdi-pencil-box-outline mr-2"></i>
                                                </a>
                                            </span>
                                            <span v-else class="pull-right">
                                                <a href="#" @click.prevent="updateNote">
                                                    <i class="text-success mdi mdi-content-save-outline mr-2"></i>
                                                </a>
                                            </span>
                                        </footer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: [
        "title",
        "show",
    ],
    data() {
        return {
            mutableNotes: [],
            selectedNote: null,
            editing: false,
            newNote: new AppForm({
                noteText: ''
            }),
        };
    },
    watch: {
        mutableNotes: function () {
            this.setupScroll();
        }
    },
    methods: {
        initSelectedNote(){
          this.selectedNote =  new AppForm({
              noteId: null,
              noteText: ''
          })
        },
        editNote(note) {
            this.selectedNote.noteId = note.id;
            this.selectedNote.noteText = note.note;
            this.editing = true;
        },
        closeNotesPanel() {
            this.$emit('close-notes-panel');
        },
        setupScroll() {
            $(".slimscrollright").slimScroll({
                height: "100%",
                position: "right",
                size: "5px",
                color: "#dcdcdc"
            });
        },
        fetchNotes() {
            axios.get('notes')
            .then((response) => {
                this.mutableNotes = response.data;
            });
        },
        createNewNote() {
            App.post('/notes/create', this.newNote)
            .then((response) => {
                this.mutableNotes.unshift(response);
                toastr.success('New Note Created');
                this.newNote.noteText = '';
            }).catch((errors) => {
                toastr.error('Could not create note!');
            })
        },
        updateNote() {
            let self = this;

            App.patch('/notes/' + self.selectedNote.noteId + '/update', this.selectedNote)
            .then((response) => {
                let index = this.mutableNotes.findIndex(note => note.id === self.selectedNote.noteId);
                this.mutableNotes[index].note = response.note;
                toastr.success('Note Updated');
                this.initSelectedNote();
                this.editing = false;
            }).catch((errors) => {
                toastr.error('Could not create note!');
            })
        },
        showDeleteConfirmation(noteId) {
            let self = this;
            swal({
                title: 'Are you sure?',
                text: "This note will be deleted",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, proceed!'
            }).then((result) => {
                if (result.value) {
                    self.deleteNote(noteId);
                }
            })
        },
        deleteNote(noteId) {
            App.delete('/notes/' + noteId + '/delete', new AppForm({
                noteId: noteId
            }))
            .then((response) => {
                let index = this.mutableNotes.findIndex(note => note.id === noteId);
                this.mutableNotes.splice(index, 1);
                toastr.success('Note deleted');
            }).catch((errors) => {
                toastr.error('Could not delete this note!');
            })
        }
    },
    mounted() {
        this.fetchNotes();
        this.setupScroll();
        this.initSelectedNote();
    }
};
</script>

<style>
    .notes-list {
        display: block;
        max-height: 100vh;
    }
</style>
